import { addPointInteger } from 'vlcishared';

/** Formateo del tooltip de gauge y pie
 * @param {object} params elementos del parámetro a formatear
 * @param {boolean} isPie Determina si es pie o no para mostrar %
 * @returns cadena formateada.
 */
export function formatRoundTooltip(params, isPie) {
  let label = `${params.name} : `;
  label += `<span style="font-weight:bold">${addPointInteger(
    Math.round(params.value),
  )}</span>`;
  if (isPie) {
    label += `<span> (${params.percent}%)</span>`;
  }
  return params.marker + label;
}
